export default __webpack_public_path__ + "0c63924e3d57442ac4158fa6bf655628.png";